import { IdChip } from 'app/domains/common-ui/IdChip';
import { useActiveDocument } from 'shared/domains/documents';
import { ApprovalChip } from './ApprovalChip';
import { EsigningChip } from './EsigningChip';
import { LockedChip } from './LockedChip';
import { NoticeDateChip } from './NoticeDateChip';
import { SharedExternallyChip } from './SharedExternallyChip';
import { StatusChip } from './StatusChip';
import { Container } from './styles';
export function DocumentChips() {
    const { id } = useActiveDocument();
    return (<Container>
      <IdChip type="contract" id={id}/>
      <StatusChip />
      <NoticeDateChip />
      <LockedChip />
      <ApprovalChip />
      <EsigningChip />
      <SharedExternallyChip />
    </Container>);
}
